/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const POLICY_NAME = 'Policy';
export const POLICY_TYPE = 'Policy Type';
export const ASSOCIATED_IDPS = 'Associated Identity Providers';
export const NO_PASSWORD_POLICIES_FOUND = 'No password policies found';
export const DEFAULT = 'Default';
export const ACTIONS = 'Actions';
export const ASSIGN_TO_LOCATION = 'Assign to Sub-Realm';
export const ASSIGN_TO_REALM = 'Assign to Blue Yonder User Store';
export const SET_AS_DEFAULT = 'Set As Default';
export const EDIT = 'Edit';
export const DELETE = 'Delete';
export const TABS = 'tabs';
export const POLICY = 'Policy';
export const ROWS_PER_PAGE_LABEL = 'Rows per page:';
export const REALM = 'Realm';
export const CUSTOM = 'Custom';
export const BY_USER_STORE = 'Blue Yonder User Store';

